"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InstallmentPreview = exports.getFormattedAmount = exports.isPastDue = exports.isDatePassed = exports.getDateString = void 0;
const React = __importStar(require("react"));
// Local Imports
const teamsnap_ui_1 = require("@teamsnap/teamsnap-ui");
const constants_1 = require("core/constants");
const date_service_1 = require("utils/date-service");
require("./installment-preview.scss");
const getDateString = (scheduledDate) => {
    if (scheduledDate) {
        return date_service_1.DateService.dateToString(new Date(scheduledDate), date_service_1.DateFormat.SHORT_DATE);
    }
    return '';
};
exports.getDateString = getDateString;
const isDatePassed = (date) => {
    const testDate = new Date(date);
    const now = new Date();
    now.setHours(0, 0, 0, 0);
    return testDate < now;
};
exports.isDatePassed = isDatePassed;
const isPastDue = (installment) => {
    return (installment.status !== 'paid' &&
        installment.status !== 'pending' &&
        installment.status !== 'refunded' &&
        installment.status !== 'partially_refunded' &&
        installment.status !== 'unpaid' &&
        installment.scheduledDate &&
        (0, exports.isDatePassed)(installment.scheduledDate));
};
exports.isPastDue = isPastDue;
const getFormattedAmount = (amount) => {
    const dollarUS = Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });
    return dollarUS.format(+amount);
};
exports.getFormattedAmount = getFormattedAmount;
const InstallmentPreview = ({ installments, isPayable, order, }) => {
    const ORDER_IN_WAITING_FOR_PAYMENT_STATUS = order.status === 'waiting_for_payment';
    const nextInstallmentIndex = installments.findIndex((i) => i.status === 'scheduled' || i.status === 'unpaid');
    const lastPastDueInstallmentId = installments.filter(exports.isPastDue)?.slice(-1)[0]?.id;
    const failedInstallmentIndex = installments.findIndex((i) => i.id === lastPastDueInstallmentId);
    const showPayNowIndex = failedInstallmentIndex > -1 ? failedInstallmentIndex : nextInstallmentIndex;
    const payNowtype = failedInstallmentIndex > -1 ? 'past_due' : 'next_installment';
    const getPostRegUpdateType = (installment) => {
        if (!installment.modifiedByAdminAction) {
            return null;
        }
        let actionType = '';
        switch (installment.modifiedByAdminAction) {
            case 'updated':
                actionType = 'Updated';
                break;
            case 'canceled':
                actionType = 'Canceled';
                break;
            case 'logged':
                actionType = 'Logged';
                break;
            case 'created':
                actionType = 'Added';
                break;
        }
        return actionType ? `${actionType} by admin` : null;
    };
    return (React.createElement(React.Fragment, null, installments.length > 0 ? (React.createElement("ul", { className: "InstallmentPreview__payment-timeline sui-mt-1", "data-testid": "InstallmentPreview" }, installments.map((installment, i) => {
        return (React.createElement("li", { key: installment.id, "data-testid": "installment-item-preview", className: "InstallmentPreview__payment-line-item", title: installment.status },
            showPayNowIndex === i && isPayable && (React.createElement(teamsnap_ui_1.Button, { mods: "payNowButton", onClick: () => {
                    const dateParam = payNowtype === 'next_installment'
                        ? `&scheduledDate=${encodeURI(installment.scheduledDate ?? '')}`
                        : '';
                    window.location.href = `${constants_1.ORDERS_URL}/order/${installment.orderId}/payment?option=${payNowtype}${dateParam}`;
                } }, "Pay Now")),
            React.createElement("span", { className: `${(0, exports.isPastDue)(installment) ? 'u-colorNegative' : ''} sui-flex sui-gap-0.5` },
                React.createElement("span", { className: `${installment.modifiedByAdminAction === 'canceled' ? 'sui-line-through' : ''}` }, (0, exports.getFormattedAmount)((installment.feeAmount ? installment.feeAmount + installment.amount : installment.amount) / 100)),
                React.createElement("span", { className: "sui-italic sui-text-gray-8 sui-caption" }, getPostRegUpdateType(installment))),
            React.createElement("span", { className: "" },
                React.createElement("small", null,
                    !ORDER_IN_WAITING_FOR_PAYMENT_STATUS && (0, exports.getDateString)(installment.scheduledDate ?? ''),
                    (0, exports.isPastDue)(installment) && isPayable && !ORDER_IN_WAITING_FOR_PAYMENT_STATUS && React.createElement("div", null, "Past Due"),
                    ORDER_IN_WAITING_FOR_PAYMENT_STATUS && React.createElement("div", null, "Waiting for payment"),
                    installment.status === 'refunded' && React.createElement("div", null, "Refunded"),
                    installment.status === 'partially_refunded' && React.createElement("div", null, "Partially Refunded"),
                    !ORDER_IN_WAITING_FOR_PAYMENT_STATUS &&
                        installment.status !== 'scheduled' &&
                        installment.paymentMethod &&
                        installment.paymentMethod?.accountName !== 'offline' && (React.createElement("div", null,
                        installment.paymentMethod.accountName?.toUpperCase(),
                        " (**** ",
                        installment.paymentMethod.last4,
                        ")")),
                    !ORDER_IN_WAITING_FOR_PAYMENT_STATUS &&
                        installment.status !== 'scheduled' &&
                        installment.paymentMethod &&
                        installment.paymentMethod?.accountName === 'offline' && (React.createElement("div", null,
                        installment.paymentMethod.accountName.toUpperCase(),
                        " (",
                        installment.paymentMethod.accountType.slice(0, 1).toUpperCase() +
                            installment.paymentMethod.accountType.slice(1).toLowerCase(),
                        ")"))))));
    }))) : (React.createElement("p", { className: "" }, "No payments to display"))));
};
exports.InstallmentPreview = InstallmentPreview;
